export default "__VITE_ASSET__CWg8HLTq__"